module.exports = __webpack_public_path__ + "fonts/Quicksand-700-vietnamese13.acc5504.woff2";